import {
  CAMPAIGN_ENUM_TYPES,
  CAMPAIGN_SUBTYPES_ENUM,
} from '../../../../shared/constants'

export const cityMetricsTypes = {
  common: 'common',
  affiliates: 'affiliates',
}

const campaignFeatures = {
  [CAMPAIGN_ENUM_TYPES.DIRECTMAIL]: {
    disableBAFeatures: false,
    disableCityFeatures: false,
    cityMetrics: cityMetricsTypes.common,
    disableXeroInvoice: false,
    //Core
    enableArtworkAndOffers: true,
    subtypeFeatures: {
      [CAMPAIGN_SUBTYPES_ENUM.EDDM]: {
        disableUploadCodes: true,
        disableBAFeatures: true,
        //Self-Serve
        enableArtwork: true,
        enableArtworkAndOffers: false,
      },
      [CAMPAIGN_SUBTYPES_ENUM.ADM]: {
        disableUploadCodes: true,
        disableBAFeatures: true,
        //Self-Serve
        enableArtwork: true,
        enableArtworkAndOffers: false,
      },
    },
  },
  [CAMPAIGN_ENUM_TYPES.HANDTOHAND]: {
    disableBAFeatures: false,
    disableCityFeatures: false,
    cityMetrics: cityMetricsTypes.common,
    disableXeroInvoice: false,
    //Core
    enableArtworkAndOffers: true,
  },
  [CAMPAIGN_ENUM_TYPES.LETTERBOX]: {
    disableBAFeatures: false,
    disableCityFeatures: false,
    cityMetrics: cityMetricsTypes.common,
    disableXeroInvoice: false,
    //Core
    enableArtworkAndOffers: true,
  },
  [CAMPAIGN_ENUM_TYPES.INSERTS]: {
    supportedCountryCodes: ['ALL'],
    cityMetrics: cityMetricsTypes.affiliates,
    disableBAFeatures: true,
    disableCityFeatures: true,
    disableXeroInvoice: true,
  },
}

export default function CampaignFeaturesConfig(type, subtype = null) {
  const config = campaignFeatures[type]
  if (subtype) {
    const subtypeConfig = config.subtypeFeatures[subtype]
    return {
      ...config,
      ...subtypeConfig,
    }
  }
  return config
}
